module.exports = __webpack_public_path__ + "img/plusIcon.b4f40f04.svg";